(function () {
  const initMediaBanner = (section) => {
    if (!section || !section?.classList.contains("media-banner-section")) {
      return;
    }

    // finding out if it's the last section on the page
    const sections = document.querySelectorAll(
      'section[id^="shopify-section"]'
    );
    const last = sections[sections.length - 1];

    // checking out if last section has scroll animation enabled
    if (last && !last.querySelector(".media-banner--with-scroll-animation")) {
      // scroll animation is disabled — unwrap fake-section-wrapper if present
      const existingWrapper = document.querySelector(".fake-section-wrapper");
      if (existingWrapper) {
        const child = existingWrapper.querySelector('[id^="shopify-section"]');
        if (child) {
          existingWrapper.parentNode.insertBefore(child, existingWrapper);
        }
        existingWrapper.parentNode.removeChild(existingWrapper);
      }
      last.classList.remove("sticky-panel");
      last.style.transform = "";
      document.querySelector("main")?.classList.remove("background");
      document
        .querySelectorAll(".shopify-section-group-header-group")
        .forEach((item) => item.classList.remove("background"));
      document
        ?.querySelector(".breadcrumbs-wrapper")
        ?.classList.remove("background");
    }

    if (last && last.querySelector(".media-banner--with-scroll-animation")) {
      if (document.querySelector(".fake-section-wrapper") == null) {
        const section_wrapper = document.createElement("section");
        last.parentNode.insertBefore(section_wrapper, last);
        section_wrapper.appendChild(last);
        section_wrapper.classList.add("fake-section-wrapper", "sticky-wrapper");
      }

      last.classList.add("sticky-panel");
      last.style.transform = "scale(1.1)";

      // adding backgrounds to previous sections to avoid the opacity
      document.querySelector("main").classList.add("background");
      document
        .querySelectorAll(".shopify-section-group-header-group")
        .forEach((item) => item.classList.add("background"));
      document
        ?.querySelector(".breadcrumbs-wrapper")
        ?.classList.add("background");

      /**
       * Footer-reveal scale for a sticky bottom panel that sits UNDER the footer.
       *
       * DOM order: <footer>...</footer><div class="sticky-panel">...</div>
       * CSS on panel: position: sticky; bottom: 0;
       * Footer visually above panel (z-index higher).
       */
      function initFooterRevealScale({
        footer = "footer",
        panel = ".sticky-panel",
        maxScale = 1.1, // when panel fully visible
        minScale = 1.0, // when panel barely visible
        easing = 1.0, // 1 = linear; >1 makes change slower near fully-visible
        enable = true,
      } = {}) {
        if (!enable) return () => {};

        const footerEl =
          typeof footer === "string" ? document.querySelector(footer) : footer;
        const panelEl =
          typeof panel === "string" ? document.querySelector(panel) : panel;

        if (!footerEl || !panelEl) return () => {};

        // Respect reduced motion
        const prefersReduced = window.matchMedia?.(
          "(prefers-reduced-motion: reduce)"
        )?.matches;
        if (prefersReduced) {
          panelEl.style.transform = "scale(1)";
          return () => {};
        }

        let rafId = 0;
        let panelH = 0;

        const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

        const readPanelHeight = () => {
          const rect = panelEl.getBoundingClientRect();
          panelH = rect.height || panelEl.offsetHeight || 0;
        };

        const update = () => {
          rafId = 0;

          if (!panelH) readPanelHeight();
          if (!panelH) return;

          const vh =
            window.innerHeight || document.documentElement.clientHeight;

          const footerRect = footerEl.getBoundingClientRect();

          // how much of the panel is visible
          const visible = clamp(vh - footerRect.bottom, 0, panelH);
          const text_visible =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 5;

          const wrapper = panelEl.closest(".fake-section-wrapper");

          if (text_visible > 0) {
            wrapper?.classList.remove("sticky-wrapper");
          } else {
            wrapper?.classList.add("sticky-wrapper");
          }

          wrapper?.classList[text_visible > 0 ? "remove" : "add"](
            "sticky-text"
          );

          // 0 → just appeared, 1 → fully visible
          let t = visible / panelH;

          // easing (optional)
          if (easing !== 1.0) {
            t = Math.pow(t, easing);
          }

          // map visibility to scale:
          // t = 0 → 1.1
          // t = 1 → 1.0
          const s = minScale + (1 - t) * (maxScale - minScale);

          panelEl.style.transform = `scale(${s})`;
        };

        const requestUpdate = () => {
          if (rafId) return;
          rafId = requestAnimationFrame(update);
        };

        // Observe size changes (fonts, responsive, dynamic content)
        const ro = new ResizeObserver(() => {
          readPanelHeight();
          requestUpdate();
        });
        ro.observe(panelEl);

        // Scroll / resize
        window.addEventListener("scroll", requestUpdate, { passive: true });
        window.addEventListener(
          "resize",
          () => {
            readPanelHeight();
            requestUpdate();
          },
          { passive: true }
        );

        // Initial
        readPanelHeight();
        update();

        // Cleanup
        return () => {
          if (rafId) cancelAnimationFrame(rafId);
          ro.disconnect();
          window.removeEventListener("scroll", requestUpdate);
          window.removeEventListener("resize", requestUpdate);
        };
      }

      const cleanup = initFooterRevealScale({
        footer: "footer",
        panel: ".sticky-panel",
        maxScale: 1.1,
        minScale: 1.0,
        easing: 1.0,
      });

      // если нужно потом снять:
      // cleanup();
    }
  };

  initMediaBanner(document.currentScript.parentElement);

  document.addEventListener("shopify:section:select", function (event) {
    initMediaBanner(event.target);
  });

  document.addEventListener("shopify:block:change", function (event) {
    initMediaBanner(event.target);
  });

  document.addEventListener("shopify:section:change", function (event) {
    initMediaBanner(event.target);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initMediaBanner(event.target);
  });
})();
